import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { AddToLocalStorage, GetDataLocalStorage } from '../../Framework/GlobalObj';
// import { CircularProgress } from '@mui/material';
import { vehicle_api } from '../../Config';
import {  useSearchParams } from 'react-router-dom';
import PdfPopup from '../Pages/Payment Pages/PdfViewer';

const HdfcKYCPage = () => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState({});
  const [parms] = useSearchParams();
  const [, setSend] = useState(false);
  const [, setRes] = useState({});
  const [showPopup, setShowPopup] = useState(false);
  const [pdfBytes, setPdfBytes] = useState(null);
  // const navigate = useNavigate();

  useEffect(() => {
    const processKYCAndProposal = async () => {
      try {
        let req = GetDataLocalStorage('globalObj');
        req.insurance.kyc.pehchanId = parms.get('kyc_id') || req.insurance.kyc.pehchanId;

        if (parms.get('status') === 'approved' && req.insurance.kyc.pehchanId) {
          try {
            let kycResponse = await axios.post(`${vehicle_api}/insurance/kyc-verified`, req);
            req.insurance.kyc.hdfcKycResponse = kycResponse.data.data;
          } catch (error) {
            console.error("Error in KYC Verification API:", error);
          }
        }

        let proposalResponse = await axios.post(`${vehicle_api}/insurance/v1/motor/policy/proposal`, req);
        let resObj = proposalResponse.data.body;
        setRes(resObj);
        if (resObj?.StatusCode === 200) {
          let totalpremium = resObj?.Policy_Details?.TotalPremium || "";
          req.insurance.grossPremium = totalpremium;
          AddToLocalStorage('globalObj', req);
          const currentDate = new Date().toISOString().slice(2, 10).replace(/-/g, '');
          let randomDigits = Math.floor(Math.random() * 100000).toString().padStart(5, '0');
          const trnsno = `1127${currentDate}${randomDigits}`;

          req.insurance.instrumentNumber = trnsno;
          req.profile.customer.proposalNumber = resObj?.Policy_Details?.ProposalNumber
          AddToLocalStorage('globalObj', req);

          // Fetch CIS Document
          try {
            const responseData = await axios.post(
              `${vehicle_api}/insurance/v1/motor/getcisdocument`, req
            );
            console.log(responseData, "CIS Document Response");
            let pdfBase64 = responseData?.data?.body?.Resp_Policy_Document?.PDF_BYTES;
            if (pdfBase64) {
              setPdfBytes(pdfBase64);
              setShowPopup(true);

              // Wait for 5 seconds before redirecting to payment
              setTimeout(() => {
                proceedToPayment(req, totalpremium, trnsno);
              }, 5000);
            } else {
              // If no PDF found, proceed immediately to payment
              proceedToPayment(req, totalpremium, trnsno);
            }
          } catch (error) {
            console.error('Error fetching CIS document:', error);
            proceedToPayment(req, totalpremium, trnsno);
          }
        }
      } catch (error) {
        console.error('Proposal API error:', error);
      }
    };

    processKYCAndProposal();
  }, []);

  const proceedToPayment = async (req, totalpremium, trnsno) => {
    try {
      let successUrl = `https://main.dy3gwnxriq0bt.amplifyapp.com/motor/payment/success`;
      let failureUrl = `https://main.dy3gwnxriq0bt.amplifyapp.com/motor/payment/failed`;

      let checksumRes = await axios.get(
        `https://heapp21.hdfcergo.com/UAT/PaymentUtilitiesService/PaymentUtilities.asmx/GenerateRequestChecksum?TransactionNo=${trnsno}&TotalAmount=${totalpremium}&AppID=10295&SubscriptionID=S000000333&SuccessUrl=${successUrl}&FailureUrl=${failureUrl}&Source=POST`
      );

      let checksum = checksumRes.data.split('>')[2].split('<')[0];
      req.insurance.checksum = Number(checksum);

      let data1 = {
        trnsno: trnsno,
        amt: `${totalpremium}`,
        appid: '10295',
        subid: 'S000000333',
        surl: successUrl,
        furl: failureUrl,
        src: 'POST',
        chksum: `${checksum}`
      };

      setData(data1);
      AddToLocalStorage('globalObj', req);
      setSend(true);
      setLoading(false);

      setTimeout(() => {
        document?.getElementById('form')?.submit();
      }, 1000);
    } catch (error) {
      console.error('Checksum error:', error);
    }
  };

  return (
    <div>
      {loading ? (
        <PdfPopup open={showPopup} setOpen={setShowPopup} base64Pdf={pdfBytes} />
      ) : 
      (
        <form
          action="https://heapp21.hdfcergo.com/UAT/OnlineProducts/CCPGISUBSCRIBER/MakePayment.aspx"
          name="PAYMENTFORM"
          method="POST"
          id="form"
        >
          <input type="hidden" name="trnsno" value={data.trnsno} />
          <input type="hidden" name="amt" value={data.amt} />
          <input type="hidden" name="appid" value={data.appid} />
          <input type="hidden" name="subid" value={data.subid} />
          <input type="hidden" name="surl" value={data.surl} />
          <input type="hidden" name="furl" value={data.furl} />
          <input type="hidden" name="src" value="POST" />
          <input type="hidden" name="chksum" value={data.chksum} />
        </form>
      )}
    </div>
  );
};

export default HdfcKYCPage;
